const Footer = () => {
  return (
    <footer className="text-center mt-auto py-5 text-sm bg-white text-gray-400">
      Copyright © 2022 <span>Medtax Solutions Inc.</span>
    </footer>
  );
};

export default Footer;
